import { useNavigate } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useProject } from "context/ProjectContext";
import {
  getStructuredDocumentSectionsPath,
  isVersionChanged,
} from "screens/Project/screens/StructuredDocument/StructuredDocument.utils";
import { QueryAPIKey } from "utils/constants/api.constants";

const useHandleStructuredDocumentVersionChange = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { project } = useProject();

  const handleStructuredDocumentVersionChange = async (
    prevARN: string,
    nextARN: string,
    version?: string,
  ) => {
    if (!project) {
      return;
    }

    if (isVersionChanged(prevARN, nextARN)) {
      navigate(getStructuredDocumentSectionsPath(project!.id, nextARN), {
        state: { version },
      });
    } else {
      await queryClient.invalidateQueries({
        queryKey: [QueryAPIKey.GetStructuredDocument],
      });
    }
  };

  return handleStructuredDocumentVersionChange;
};

export default useHandleStructuredDocumentVersionChange;
